<template>
  <div class="flex flex-row items-center gap-2 truncate p-3">
    <RouterLink
      class="flex flex-1 flex-row items-center gap-1.5 truncate"
      :to="{
        name: 'invoice_show_route',
        params: { invoicing_id: invoice_id }
      }"
    >
      <span class="truncate">
        {{ titleValue }}
      </span>
    </RouterLink>
  </div>
</template>
<script>

export default {
  name: 'PaymentTitleElement',
  props: {
    column: {
      type: Object,
      required: true
    },
    payment: {
      type: Object,
      required: true
    },
  },
  computed: {
    titleValue() {
      return this.payment[this.column.field]['label']
    },
    invoice_id() {
      return this.payment[this.column.field]['invoice_id']
    }
  }
}
</script>
